import { formatDate } from "../../../utils/utils";


export const ExportExcel = (tables, nombreArchivo, nomTitulo , flagTablaOculta) => {
    let combinedHTML = `<table>`;
    combinedHTML += `
    <tr>
        <td colspan ="10" style="font-size:23px;text-align:center;text-decoration:underline;" rowspan="2">${nomTitulo}</td>
    </tr>
    <tr><td colspan="10"></td></tr>`

    tables.forEach((nomTabla) => {
        let tabla = '<table style="border: 1px solid #ddd">'
        // Obtener thead
        tabla += '<thead>'
        const theadRows = document.querySelectorAll(`#${nomTabla} thead > tr${flagTablaOculta ? ':visible' : ''}`);
        theadRows.forEach(row => {
            tabla += '<tr style="background: #6098b9 !important; color: #fff; font-size: 11pt;">'// border: 1px solid #ddd;
            tabla += row.innerHTML;
            tabla += '</tr>'
        });
        tabla += '</thead>'
        tabla += '<tbody>'
        // htmlTabla.append(htmlTablaThead[0]);
        const tbodyRows = document.querySelectorAll(`#${nomTabla} tbody > tr${flagTablaOculta ? ':visible' : ''}`);
        tbodyRows.forEach((row,i) => {
            tabla += `<tr style="background:${i % 2 == 0 ? '#fff' : '#ebf7fd !important'};">`// border: 1px solid #ddd;
            tabla += row.innerHTML;
            tabla += '</tr>'
        })
        tabla += '</tbody>'

        // Obtener tfoot
        tabla += '<tfoot>'
        const tfootRows = document.querySelectorAll(`#${nomTabla} tfoot > tr${flagTablaOculta ? ':visible' : ''}`);
        tfootRows.forEach((row,i) => {
            tabla += `<tr style="border: 1px solid #ddd">`
            tabla += row.innerHTML;
            tabla += '</tr>'
        })
        tabla += '</tfoot>'
        tabla += '</table><br></br>'

        combinedHTML += tabla;
    });

    combinedHTML += `</table>`;

    // Crear archivo Excel con BOM para UTF-8
    const BOM = '\uFEFF'; // Byte Order Mark
    const blob = new Blob([BOM + combinedHTML], { type: 'application/vnd.ms-excel;charset=utf-8;' });

    const a = document.createElement('a');
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = `${nombreArchivo}_${formatDate(new Date())}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}